/* eslint-disable camelcase */
import {
  isEmptyObject,
} from '~/assets/js/utils/is-empty-object'

function ensureFormatBanners (provider, banners = []) {
  return banners.map(({ desktop, mobile, ...rest }) => ({
    ...rest,
    src: {
      'mobile@1x': provider(mobile, { dpr: 1, operation: 'width', width: 328, height: 110 }),
      'mobile@2x': provider(mobile, { dpr: 2, operation: 'width', width: 328, height: 110 }),
      'desktop@1x': provider(desktop, { dpr: 1, operation: 'width', width: 1102, height: 158 }),
      'desktop@2x': provider(desktop, { dpr: 2, operation: 'width', width: 1102, height: 158 }),
    },
  }))
}

function ensureFormat (provider, campaign = {}) {
  const { banners, ...rest } = campaign

  const formattedBanners = ensureFormatBanners(provider, banners)

  return {
    banners: formattedBanners,
    ...rest,
  }
}

function betweenStartAndEndDate ({ start_date, end_date }) {
  const now = Date.now()

  start_date = new Date(start_date).getTime()
  end_date = end_date && new Date(end_date).getTime()

  if (!end_date) return start_date <= now

  return end_date >= now && start_date <= now
}

export function CampaignConfig (dataSource, provider) {
  const campaigns = dataSource ? dataSource.filter(betweenStartAndEndDate) : []

  this.getCampaignFor = (level) => {
    let filteredCampaign = campaigns.find((campaign) => {
      return campaign.default === false && campaign.levels.some(({ levels_id }) => levels_id.name === level)
    })

    if (isEmptyObject(filteredCampaign)) {
      filteredCampaign = campaigns.find((campaign) => {
        return campaign.levels.some(({ levels_id }) => levels_id.name === level) && campaign.default
      })
    }

    return ensureFormat(provider, filteredCampaign)
  }

  this.getBannerForCampaing = (campaign, context, size) => {
    const banner = campaign.banners.find((banner) => {
      return banner.context === context && banner.size === size
    })

    if (!banner.url.match(/^(https?:)?\/\//)) {
      banner.url = 'https://querobolsa.com.br' + banner.url
    }

    return banner
  }
}
